import { FAQ } from '../../const';
import './accordion.scss';

const Accordion = () => (
  <ol className="accordion__markerPlusMinus">
    {FAQ.map((option) => (
      <li key={option.id} data-attr-id={option.id}>
        <details>
          <summary>
            <h3>{option.title}</h3>
          </summary>
          <div className="content">
            {typeof option.text === 'string' ? (
              <p>{option.text}</p>
            ) : (
              option.text
            )}
          </div>
        </details>
      </li>
    ))}
  </ol>
);

export default Accordion;
